import { InfoCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoButtonModal from './info-button-modal.component';
import { InfoButtonContainer, InfoIcon, InfoText } from './info-button.styles';

interface InfoButtonProps {
  onlyIcon?: boolean;
}

const InfoButton = ({ onlyIcon = false }: InfoButtonProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [t] = useTranslation();

  const handleShowModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <InfoButtonContainer onClick={handleShowModal} data-testid='info-button'>
        <InfoIcon>
          <InfoCircleOutlined data-testid='info-icon' />
        </InfoIcon>
        {!onlyIcon && <InfoText data-testid='info-text'>{t('pages.regional_overview.digital_traps.info_button.how_it_works')}</InfoText>}
      </InfoButtonContainer>
      <InfoButtonModal isVisible={isModalVisible} onClose={handleCloseModal} />
    </>
  );
};

export default InfoButton;
